import React from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../../../../redux/hooks';
import { builderSelectedOptionsSelector } from '../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../utils/types';
import { QueryType } from '../../../../../utils/apollo/graphqlSchema';
import { RETENTION_BASIC_VIEW_KEYS } from '../../../../../utils/builder';
import CohortUnit from './CohortUnit';
import RetentionUnit from './RetentionUnit';
import CalculationKey from './CalculationKey';
import CalculationWindow from './CalculationWindow';
import RetentionTimeWindow from './RetentionTimeWindow';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const RetentionCriteria = () => {
  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );

  assertCondition(selectedOptions?.type === QueryType.Retention);

  const { retentionView } = selectedOptions;

  return (
    <Container>
      <CohortUnit />
      <RetentionUnit />
      <RetentionTimeWindow />
      {RETENTION_BASIC_VIEW_KEYS.includes(retentionView) && (
        <>
          <CalculationKey />
          <CalculationWindow />
        </>
      )}
    </Container>
  );
};

export default RetentionCriteria;
